import {createContext} from "react";

export const PlatformBrandContext = createContext({
        platforms: [],
        allBrands: [],
    }
);
